import AsyncStorage from "@react-native-async-storage/async-storage";
import { useNavigation, useRoute } from "@react-navigation/native";
import React, { useEffect, useState } from "react";
import { ActivityIndicator, Modal, Text, View } from "react-native";
import GradientButton from "../../components/GradientButton";
import HeaderDefault from "../../components/HeaderDefault";
import ModalSuccess from "../../components/ModalSuccess";
import paymentService from "../../services/paymentService";
import { formatCoin } from "../../utils/formatNumber";
import toast from "../../utils/toast";
import HeaderTabs from "../../components/HeaderTabs";
import { styles } from "./styles";
import { FormattedMessage } from "react-intl";
import { TouchableOpacity } from "react-native-gesture-handler";

const DepositCreditCardSummary = () => {
  const [value, setValue] = useState(0);
  const navigation = useNavigation();
  const route = useRoute();
  const [selectedCard, setSelectedCard] = useState();
  const [creditCard, setCreditCard] = useState();
  const [creditCardHolderInfo, setCreditCardHolderInfo] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      const value = parseFloat(await AsyncStorage.getItem("depositAmount"));
      setValue(value);
    };
    loadData();
  }, []);

  async function createCreditCardPayment() {
    setIsLoading(true);
    const token = await AsyncStorage.getItem("JWT_TOKEN");
    try {
      if (selectedCard) {
        await paymentService.createWithExistingCreditCard(
          token,
          value,
          selectedCard.id
        );
      } else {
        await paymentService.createWithNewCreditCard(
          token,
          value,
          creditCard,
          creditCardHolderInfo
        );
      }

      setModalVisible(true);
    } catch (err) {
      console.log(err.response.data);
      if (err.response.data.message) {
        toast(err.response.data.message, "#DA1414");
      } else {
        toast(
          intl.formatMessage({ id: "depositcreditcardsummary.algoDeuErrado" }),
          "#DA1414"
        );
      }
    } finally {
      setIsLoading(false);
    }
  }

  const cardNumber = selectedCard
    ? selectedCard.number
    : creditCard
    ? creditCard.number.substring(creditCard.number.length - 4)
    : "****";

  return (
    <>
      <View style={{ flex: 1 }}>
        <HeaderTabs
          title={
            <FormattedMessage id="depositcreditcardsummary.depositarBrl" />
          }
        />
        <View style={styles.container}>
          <View>
            <Text style={styles.mainHeaderTxt}>
              <FormattedMessage id="depositcreditcardsummary.revisarInformacoes" />
            </Text>
            <View style={styles.headerInfo}>
              <View>
                <Text style={styles.subtitle}>
                  <FormattedMessage id="depositcreditcardsummary.depositoCartao" />
                </Text>
                <Text style={styles.value}>
                  <FormattedMessage id="depositcreditcardsummary.R$" />
                  {formatCoin(value)}
                </Text>
              </View>
            </View>
            <View style={styles.cardInfo}>
              <View>
                <Text>
                  <FormattedMessage id="depositcreditcardsummary.cartaoCredito" />
                </Text>
                <Text style={styles.subtitle}>
                  <FormattedMessage id="depositcreditcardsummary.****" />
                  {cardNumber}
                </Text>
              </View>
            </View>
          </View>

          <View style={styles.buttons}>
            {isLoading ? (
              <ActivityIndicator color="#2797A2" size="large" />
            ) : (
              <TouchableOpacity
                onPress={createCreditCardPayment}
                style={styles.button}
              >
                <Text style={{ color: "#FFF" }}>
                  {" "}
                  <FormattedMessage id="depositcreditcardsummary.finalizarPagamento" />
                </Text>
              </TouchableOpacity>
            )}
          </View>
        </View>
      </View>

      <Modal
        animationType="fade"
        transparent={false}
        visible={modalVisible}
        statusBarTranslucent={true}
        onRequestClose={() => setModalVisible((visible) => !visible)}
      >
        <ModalSuccess
          handleCloseModal={() => {
            setModalVisible(false);
            navigation.navigate("Home");
          }}
          text={
            <FormattedMessage id="depositcreditcardsummary.pagamentoEfetuado" />
          }
          textColor={<FormattedMessage id="depositcreditcardsummary.sucesso" />}
          img={2}
          positionHeader={"left"}
        />
      </Modal>
    </>
  );
};

export default DepositCreditCardSummary;
